import { adBlockElName } from "@gik/ads/components/AdContainer";
import ZonePool from "@gik/ads/ZonePool";
import { useEnvStore } from "@gik/core/store/EnvStore";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import classnames from "classnames";
import React from "react";

export interface IAdGlareProps {
	zone: string | ZonePool;
	fallbackBackEl?: JSX.Element;
}

export default function AdGlareComp({ zone, fallbackBackEl }: IAdGlareProps) {
	const [scriptRef, setScriptRef] = React.useState<HTMLScriptElement>(null);
	const [zoneId, setZoneId] = React.useState<string>(null);
	const [showFallback, setShowFallback] = React.useState<boolean>(!zone);
	const placeHolderRef = React.useRef<HTMLSpanElement>(null);

	const blockName = "adglare";
	const blockClassNames: string = classnames([blockName]);

	const placeholderElName = `${blockName}__placeholder`;
	const placeholderElClassNames: string = classnames([
		placeholderElName,
		adBlockElName,
		showFallback ? `${adBlockElName}--fallback` : undefined,
	]);

	React.useEffect(() => {
		if (!zoneId) {
			if (zone instanceof ZonePool) {
				setZoneId(zone.getZone());
			} else if (typeof zone === "string") {
				setZoneId(zone);
			}
		}

		return () => {
			if (zone instanceof ZonePool) {
				zone.freeZone(zoneId);
			}
		};
		// eslint-disable-next-line
	}, []);

	React.useEffect(() => {
		if (!scriptRef && zoneId) {
			const scriptElement = document.createElement("script");
			scriptElement.async = true;
			scriptElement.setAttribute("data-cfasync", "false");
			scriptElement.src =
				"//" +
				useEnvStore.getState().ADGLARE_NAME +
				".engine.adglare.net/?" +
				zoneId +
				"&cb=" +
				Date.now() +
				Math.random();

			scriptElement.onload = () => {
				setTimeout(() => {
					setShowFallback(placeHolderRef.current?.children.length == 0);
				}, 2000);
			};

			scriptElement.onerror = () => {
				setShowFallback(true);
			};

			setScriptRef(scriptElement);

			const firstScriptElement = document.getElementsByTagName("script")[0];
			firstScriptElement.parentNode.insertBefore(
				scriptElement,
				firstScriptElement,
			);
		}
		// eslint-disable-next-line
	}, [zoneId]);

	return (
		<div className={blockClassNames}>
			<span
				ref={placeHolderRef}
				className={placeholderElClassNames}
				id={`zone${zoneId}`}
			>
				{showFallback && fallbackBackEl}
			</span>
		</div>
	);
}

export const AdGlare = withComponentErrorBoundary(AdGlareComp);
